var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
// Which generation flow creators get: 'route' (new) | 'legacy' (walls rollback).
export function getGeneratorMode() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield client.get('/settings/generator-mode')).mode;
    });
}
export function updateGeneratorMode(mode) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield client.patch('/settings/generator-mode', { mode })).mode;
    });
}
export function getApiKeyStatus() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/settings/api-keys');
    });
}
// Partial update: a non-empty string sets a key, null clears it, an omitted
// provider is left unchanged. Returns the new (masked) status.
export function updateApiKeys(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch('/settings/api-keys', payload);
    });
}
// Which MODEL each provider runs (one per provider; text+vision share it).
export function getProviderModels() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/settings/provider-models');
    });
}
// Partial update: a non-empty string sets the model id, null resets to default.
export function updateProviderModels(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch('/settings/provider-models', payload);
    });
}
// Which provider runs which AI job. Stored server-side; every generation job
// resolves its provider through it.
export function getAiRouting() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/settings/ai-routing');
    });
}
// Partial update: only the listed tasks change. A task/provider pair outside the
// capability matrix is rejected with a 400.
export function updateAiRouting(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch('/settings/ai-routing', payload);
    });
}
// --- Per-user generation quotas -------------------------------------------------
export function getQuotaDefaults() {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield client.get('/settings/generation-quotas');
        return res.defaults;
    });
}
// Sets the defaults new users are seeded with; applyToExisting also resets every
// already-tracked user to these values. Returns the new defaults + how many users
// were reset.
export function updateQuotaDefaults(defaults, applyToExisting) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch('/settings/generation-quotas', { defaults, applyToExisting });
    });
}
export function listUserQuotas(search) {
    return __awaiter(this, void 0, void 0, function* () {
        const q = search ? `?search=${encodeURIComponent(search)}` : '';
        return client.get(`/settings/generation-quotas/users${q}`);
    });
}
export function updateUserQuota(username, quotas) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/settings/generation-quotas/users/${encodeURIComponent(username)}`, { quotas });
    });
}
